import React from 'react';
import Link from '@mui/material/Link';
import { PRIMARY_LINK_CLASS_NAME } from '../../../theme/constants/link';


const parseLinkParagraphNodes = (text = '') => {
  const LINK_PATTERN = /\[([^\]]+)\]\[([^\]]+)\]/g;
  const nodes = [];
  let lastIndex = 0;
  let key = 0;
  let match;

  while ((match = LINK_PATTERN.exec(text)) !== null) {
    const [fullMatch, label, url] = match;
    const start = match.index;
    const end = start + fullMatch.length;

    if (start > lastIndex) {
      nodes.push(
        <React.Fragment key={`txt-${key++}`}>
          {text.slice(lastIndex, start)}
        </React.Fragment>,
      );
    }

    nodes.push(
      <Link
        className={PRIMARY_LINK_CLASS_NAME}
        key={`lnk-${key++}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </Link>,
    );

    lastIndex = end;
  }

  if (lastIndex < text.length) {
    nodes.push(
      <React.Fragment key={`txt-${key++}`}>
        {text.slice(lastIndex)}
      </React.Fragment>,
    );
  }

  return nodes.length > 0 ? nodes : text;
};

export default parseLinkParagraphNodes;